import React from 'react';
import {
    Switch,
    Route,
    Redirect,
    withRouter,
} from 'react-router';
import { hasAccessTokenInLocalStorage, createReturnUrl, getReturnUrl } from '_helpers';
import { connect } from 'react-redux';
import { IRootState } from '../redux/store/configureStore';
import AuthorizedHandler from './AuthorizedHandler';
import UnAuthorizedHandler from './UnAuthorizedHandler';

const Routes = () => {
    if (hasAccessTokenInLocalStorage()) {
        const returnUrl = getReturnUrl();

        return (
            <Switch>
                {returnUrl && <Redirect to={returnUrl} />}
                <Redirect path="/login" to="/" />
                <Redirect path="/reset-password" to="/" />
                <Redirect exact path="/" to="/exam-applications" />
                <Route
                  path="/"
                  render={({ location }) => (
                    <AuthorizedHandler location={location} />
                )}
                />
            </Switch>
        );
    }

    createReturnUrl();

    return (
        <Switch>
            <Route
              path="/"
              render={({ location }) => (
                <UnAuthorizedHandler location={location} />
            )}
            />
            <Redirect to="/login" />
        </Switch>
    );
};

const mapState = (state: IRootState) => ({
    auth: state.auth,
});

export default withRouter(connect(mapState)(Routes));
